import { Controller } from "@hotwired/stimulus"

// Puts the TV view into the browser's full screen and back, so a wall screen
// shows the board without the browser's own bars. The whole document goes
// full screen, so this button stays on screen to leave it again.
export default class extends Controller {
  static targets = ["label"]

  connect() {
    this.element.hidden = !document.fullscreenEnabled
    this.onChange = () => this.sync()
    document.addEventListener("fullscreenchange", this.onChange)
    this.sync()
  }

  disconnect() {
    document.removeEventListener("fullscreenchange", this.onChange)
  }

  toggle() {
    if (document.fullscreenElement) {
      document.exitFullscreen()
    } else {
      document.documentElement.requestFullscreen().catch(() => {})
    }
  }

  sync() {
    const label = document.fullscreenElement ? "Exit full screen" : "Full screen"
    this.element.title = label
    this.labelTarget.textContent = label
  }
}
